import { Link } from "react-router-dom";
import React from "react";
import { formattedPrice } from "../utils";
import { useTranslation } from "react-i18next";

const ProductItem = (props) => {
  const { item, type } = props || {};
  const { t } = useTranslation();

  return (
    <Link to={"/product/" + item?.id}>
      <div className="products-item">
        <div className="products-item-holder">
          <div className="products-item-image">
            <img
              src={item?.image}
              className="img-fluid image-product-img"
              alt="Fuka"
            />
            {/* {item?.discount && (
              <img
                src="/images/bf-logo.svg"
                className="img-fluid action-logo-badge"
                alt="Fuka"
              />
            )} */}
          </div>
          <div className="products-item-text">
            <h3>{item?.name}</h3>
            <div className="product-price-wrapper">
              {item?.discount ? (
                <>
                  {/* Nova cena */}
                  <p className="new-price">
                    {type == "coffee" && t("other.from")}{" "}
                    {formattedPrice(item?.discountPrice)} <small>RSD</small>
                  </p>

                  {/* Stara cena – precrtana */}
                  <p className="old-price">
                    {formattedPrice(item?.price)} <small>RSD</small>
                  </p>
                </>
              ) : (
                // Bez popusta — samo jedna cena
                <p className="new-price">
                  {t("other.from")} {formattedPrice(item?.price)}
                  <small>RSD</small>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductItem;
